import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import ConferenceLecturerTemplate from '@components/ConferenceLecturer/ConferenceLecturer';
import useTranslations from '@hooks/useTranslation';
import { getApiURL } from '../../constants';
import { COMPONENT_TYPE } from '../../interfaces/Conference';
import { IColors, IConferenceItem } from '../../interfaces/Conference';
import {
    Lecturer,
    LecturerDescription,
    LecturerImage,
    LecturerLink,
    LecturerName,
    Lecturers,
    Title,
    TitleSymbol,
    Wrapper,
    Description
} from './ConferenceLecturers.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferenceLecturersTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [selectedPerson, setSelectedPerson] = useState({});

    const handlePersonClick = (person) => {
        setIsDetailOpen(true);
        setSelectedPerson(person);
    };

    const onlyLecturers = conf?.lectors.filter((item) => item?.type === 1);

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.PERSONS}`}>
            <Title colors={colors}>
                {t('conference.component.lecturers.title')}
                <TitleSymbol colors={colors} />
            </Title>
            <Description>{conf?.conference?.redactorTexts?.lectorDescription}</Description>

            {onlyLecturers.length > 0 && (
                <>
                    <Lecturers>
                        {onlyLecturers.map((item, index) => (
                            <Lecturer key={`lecturer${index}`}>
                                {item.photo && (
                                    <LecturerLink onClick={() => handlePersonClick(item)}>
                                        <LecturerImage
                                            src={`${getApiURL()}/media/people/${item?.photo}`}
                                            colors={colors}
                                            confType={conf?.conference?.type}
                                        />
                                    </LecturerLink>
                                )}
                                {!item.photo && (
                                    <LecturerLink onClick={() => handlePersonClick(item)}>
                                        <LecturerImage src="/public/avatar.svg" />
                                    </LecturerLink>
                                )}

                                <LecturerName colors={colors}>
                                    {item?.titles?.before_name &&
                                        `${item?.titles?.before_name} `
                                    }
                                    {item.name} {item.surname}
                                    {item?.titles?.after_name &&
                                        `, ${item?.titles?.after_name}`
                                    }
                                </LecturerName>
                                <LecturerDescription>
                                    {item.position}
                                    {item.company && item?.position?.length > 0 && <>, </>}
                                    {item.company}
                                </LecturerDescription>
                            </Lecturer>
                        ))}
                    </Lecturers>
                </>
            )}

            {isDetailOpen && (
                <ConferenceLecturerTemplate
                    onClose={() => setIsDetailOpen(false)}
                    person={selectedPerson}
                    colors={colors}
                />
            )}
        </Wrapper>
    );
};

export default ConferenceLecturersTemplate;
